<template src="@/templates/datePicker/single.html"></template>

<script>
export default {
  name: "dataPickerSingle",
  props: ["placeHolder", "identifier"],
  data() {
    return {
      currentDate: null,
      inputProps: {
        class:
          "w-full shadow appearance-none border rounded py-2 px-3 text-gray-700 hover:border-blue-5",
        style: "width: 100%;margin-bottom: 2px",
        placeholder: this.placeHolder,
        readonly: true,
      },
      identifierKey: this.identifier,
    };
  },
  methods: {
    updateDatePicked(identifierKey) {
      this.$emit("datePicked", this.currentDate, identifierKey);
    },
  },
};
</script>
